


























import Vue from 'vue';

export default Vue.extend({
  computed: {
    accordionContentClass() {
      const cssClass = [];
      if(this.small) cssClass.push(`accordion-content--small`);
      if(this.transparent) cssClass.push(`accordion-content--transparent`);
      if(this.press) cssClass.push(`accordion-content--press`);
      return cssClass.join(` `);
    },
    accordionItemClass() {
      const cssClass = [];
      if(this.small) cssClass.push(`accordion-item--small`);
      if(this.transparent) cssClass.push(`accordion-item--transparent`);
      if(this.press) cssClass.push(`accordion-item--press`);
      return cssClass.join(` `);
    },
  },
  props: {
    contentWrapperClass: {
      default: ``,
      type: String,
    },
    press: {
      default: false,
      type: Boolean,
    },
    small: {
      default: false,
      type: Boolean,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    transparent: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    toggle(): void {
      (this.$refs.accordionLink as HTMLAnchorElement).click();
    },
  },
});
